<div class="cta-container">
  <h2 class="blaak primary">{{ data?.name }}</h2>
  <p [innerHtml]="data?.description"></p>
  <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-around center" fxLayoutGap="20px">
    <div fxFlex="0 0 calc(50% - 20px)" *ngFor="let button of data?.buttons" class="elt">
      <button class="btn btn-secondary type--uppercase" fxLayout="column" (click)="callAction(button.url)" fxLayoutAlign="top center">
        <mat-icon *ngIf="button.icon && button.icon !== ''" [inline]="true">{{ button.icon }}</mat-icon>
        <p>{{ button.label }}</p>
      </button>
    </div>
  </div>
</div>
